<bx-card>
  <bx-card-header
    [title]="'property-details.status-matrix.title' | translate"
    [supportingTitle]="'property-details.status-matrix.supportingTitle' | translate"
    [divider]="true"
  ></bx-card-header>

  <div class="grid w-full grid-cols-[180px_repeat(9,minmax(80px,1fr))] items-start">
    <!-- Header row -->
    <div class="border-border-secondary h-full border-r"></div>
    <div class="bxi-table-header flex items-center justify-center">{{ 'system.total' | translate }}</div>
    @for (col of columns; track col.key) {
      <div
        class="bxi-table-header flex items-center justify-center"
        [class.border-l]="isGatewayGroupStart(col.key)"
        [class.border-border-secondary]="isGatewayGroupStart(col.key)"
        [class.bg-bg-tertiary]="!col.includeInTotal"
        [title]="translateDeviceTypeKey(col.key)"
      >
        {{ translateDeviceTypeAbbreviation(col.key) }}
      </div>
    }

    <hr class="bxi-table-separator-secondary" />

    <!-- Installed devices row -->
    <div class="bxi-table-cell border-border-secondary justify-center border-r">
      {{ 'property-details.status-matrix.row.installedDevices' | translate }}
    </div>
    <div class="bxi-table-cell items-center">{{ matrixData()?.total?.installedCount ?? '-' }}</div>
    @for (col of columns; track col.key) {
      <div
        class="bxi-table-cell items-center"
        [class.border-l]="isGatewayGroupStart(col.key)"
        [class.border-border-secondary]="isGatewayGroupStart(col.key)"
        [class.bg-bg-tertiary]="!col.includeInTotal"
      >
        {{ matrixData()?.byDeviceType?.get(col.key)?.installedCount ?? '-' }}
      </div>
    }

    <hr class="bxi-table-separator-secondary" />

    <!-- Severity row -->
    <div class="bxi-table-cell border-border-secondary justify-center border-r">
      {{ 'deviceDetails.deviceStatus.severity' | translate }}
    </div>
    <div class="bxi-table-cell flex flex-col items-center gap-0!">
      <ng-container *ngTemplateOutlet="severityDots; context: { counts: matrixData()?.total?.severityCounts }"></ng-container>
    </div>
    @for (col of columns; track col.key) {
      <div
        class="bxi-table-cell flex flex-col items-center gap-0!"
        [class.border-l]="isGatewayGroupStart(col.key)"
        [class.border-border-secondary]="isGatewayGroupStart(col.key)"
        [class.bg-bg-tertiary]="!col.includeInTotal"
      >
        <ng-container
          *ngTemplateOutlet="severityDots; context: { counts: matrixData()?.byDeviceType?.get(col.key)?.severityCounts }"
        ></ng-container>
      </div>
    }
  </div>

  <hr class="bxi-table-separator-secondary w-full" />

  <div class="gap-lg p-3xl flex w-full justify-end">
    @for (cardinality of severityDisplayOrder; track cardinality) {
      <div class="gap-xs flex items-center">
        <span class="block size-2.5 rounded-full" [class]="getSeverityClass(cardinality)"></span>
        <span class="text-text-secondary text-sm">{{ translateSeverityLabel(cardinality) }}</span>
      </div>
    }
  </div>
</bx-card>

<ng-template #severityDots let-counts="counts">
  @for (s of counts; track s.cardinality) {
    <div [class.opacity-25]="s.count === 0" class="grid grid-cols-[1fr_1fr] items-center gap-1">
      <span
        class="ml-auto block size-2.5 rounded-full"
        [class]="getSeverityClass(s.cardinality)"
        [attr.data-testid]="'severityDot-' + s.cardinality"
      ></span>
      <span class="justify-self-start text-sm font-medium">{{ s.count }}</span>
    </div>
  }
</ng-template>
